import React from "react";

const PageHeader = (props) => {
  return (
    <>
      <div className="section page-header">
        <div className="container-full-width">
          <div className="title-desc-wrapper ">
            <h1 className="page-title display-2 animate__animated animate__fadeInUp">{props.title}.</h1>
            <div className="description animate__animated animate__fadeInUp ">
              {props.description}
            </div>

          </div>
          
        </div>
      </div>
    </>
  );
};

export default PageHeader;
